import Skeleton from 'antd/es/skeleton/Skeleton';
import SkeletonAvatar from './Avatar';
import SkeletonButton from './Button';
import SkeletonInput from './Input';
import SkeletonImage from './Image';
import { withConfigProvider } from '../config-provider';
Skeleton.Button = SkeletonButton;
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Input = SkeletonInput;
Skeleton.Image = SkeletonImage;
export default withConfigProvider(Skeleton);
